<template>
	<CommonForm :strategyList="strategyList">
		<el-col :span="7" class="col-h">
				<el-form-item label="深度转化" prop="deep" >
					<el-switch v-model="formData.deep" @change="handleDeepChange"/>
				</el-form-item>
			</el-col>
			<el-col :span="7" class="col-h" v-if="!global.isPosition">
				<el-form-item label="转化名称" prop="target" required>
					<el-select v-model="formData.target" @change="handleTargetChange(['deepName'])">
						<el-option 
							v-for="item in ( global.conversionNameList[global.formData.app_id] || [] )" 
							:label="item.effect_name" :key="item.tracking_id" 
							:value="item.tracking_id"
						/>
					</el-select>
				</el-form-item>
			</el-col>
			<el-col :span="7" class="col-h">
				<el-form-item label="期望转化成本"  :rules="moneyRules">
					<el-input v-model="formData.cost" placeholder="请输入价格" @input="(value)=>handleInput('cost', value)" />
				</el-form-item>
				<div class="form-item__tip" v-if="priceAvg">
					<TipInfo :data="priceAvg"/>
				</div>
			</el-col>
			<slot name="top"/>
			<!-- <el-col :span="7" class="col-h">
				<el-form-item label="转化目标"  >
					<span class="font12px text-color-gray">次留</span>
				</el-form-item>
			</el-col> -->
			<el-col :span="24" class="col-h" v-if="global.isPosition">
				<el-row class="row-box">
					<span class="border-title">二阶出价</span>
					<div v-for="item in global.appList" :key="item.value" class=" row-box-item" >
						<p class="app_name text-color-normal">{{ item.app_name }}</p>
						<el-form-item label="转化名称"  :rules="[{ required: true, message: '请选择' }]">
							<el-select v-model="formData[item.value]" @change="handleTargetChange([`deep_${item.value}` , `type_${item.value}`])">
								<el-option 
									v-for="item in ( global.conversionNameList[item.value] || [] )" 
									:label="item.effect_name" :key="item.tracking_id" 
									:value="item.tracking_id"
								/>
							</el-select>
						</el-form-item>
					</div>
					
				</el-row>
			</el-col>
		
			<slot/>
		
	</CommonForm>
</template>

<script>
import CommonForm from './commonForm.vue'
import { validNum } from '@/utils/validate'
import { numStrip } from '@/utils'
import TipInfo from './tipInfo'
export default {
	inject: [ 'global', 'formData' , 'moneyRules'],
	components: { CommonForm , TipInfo},
	props: {
		strategyList: {
			type: Array,
			default: ()=> null
		}
	},
	data() {
		return {
			targetList:[], // 竞价目标
			priceAvg: '', // 出价均值
			
		}
	},
	computed: {
		
		
	},
	methods: {
		handleDeepChange(isDeep) {
			if(isDeep) {
				return;
			}
			this.$set(this.formData, 'deepName', '');
			this.$set(this.formData, 'deepType', '');
			this.$set(this.formData, 'deepCost', '');
			this.global.appList.forEach(item=> {
				this.$set(this.formData, `deep_${item.value}`, '')
				this.$set(this.formData, `type_${item.value}`, '')
			})
		},
		handleTargetChange(keys) {
			keys.forEach((key)=> {
				this.$set(this.formData, key, '');
			});
			this.avgValue(this.formData.cost)
		},
		handleInput(key, value) {
			if(!validNum(value)) {
				this.priceAvg = ''
				return 
			}
			const num = this.global.handleValidNumber(value) || value;
			if (num) {
				this.formData[key] = num;
			}
			this.avgValue(this.formData[key]);
		},
		async avgValue(value) {
			const { isPosition, appList } = this.global;
			if(!value) {
				return
			}
			const params = {
				price_type: this.formData.way,
				ocpc_strategy: this.formData.strategy,
				tracking_id: !isPosition? [this.formData.target] : appList.map(item=> this.formData[item.value]),
			};
			if(!isPosition && !this.formData.target) {
				return
			}else if(isPosition && !appList.every(item=> this.formData[item.value])) {
				return
			}
			const result = await this.global.getBatchConversionPrice(params);
			if(!result.conversion_cost_avg) {
				this.priceAvg = '';
				return
			}
			const n = numStrip(value - result.conversion_cost_avg);
			if (n>0) {
				this.priceAvg = `高${n}`;
			}else if(n === 0) {
				this.priceAvg = `${n}`;
			}else {
				this.priceAvg = `低${-n}`;
			}
		}
	},
	watch: {
		'formData.strategy'() {
			this.avgValue(this.formData.cost);
		}
	}
}
</script>

<style lang="scss" scoped>
.col-h {
	min-height: 52px;
}
.row-box {
	border: 1px solid #dcdfe6;
	margin: 0 12px 20px;
	border-radius: 8px;
	padding-top: 20px;
	position: relative;
	display: flex;
	flex-wrap: wrap;
	.app_name {
		margin-top: 10px;
		padding-left: 37px;
	}
	&-item {
		background: #f5f5f5;
		border-radius: 6px;
		overflow: hidden;
		margin: 0 20px 20px;
		width: calc(50% - 40px);
	}
}
.border-title {
	position: absolute;
	top: -8px;
	left: 20px;
	color: #606266;
	background: #fff;
}
.form-item__tip {
	margin-top: -16px;
	margin-left: 100px;
	color: #666;
	font-size: 12px;
}
</style>